import { strCamelCase } from "@hydrosoft/utils";
export class Utils {
    static getAttributes = (attributes, ignored = ["class"], prefix = "data-hv") => {
        const fixJson = (value) => {
            return value.replace(/(^|[^\\])'/g, '$1"').replace(/\\'/g, "'");
        };
        const convertValue = (value) => {
            if (value === "" || (typeof value === "string" && value.trim() === "")) {
                return value;
            }
            if (!isNaN(+value)) {
                value = Number(value);
            }
            if (value === "true" || value === "false") {
                value = value === "true";
            }
            if (typeof value === "string" &&
                value.startsWith("[") &&
                value.endsWith("]")) {
                value = JSON.parse(fixJson(value));
            }
            if (typeof value === "string" &&
                value.startsWith("{") &&
                value.endsWith("}")) {
                value = JSON.parse(fixJson(value));
            }
            return value;
        };
        const options = {};
        Object.keys(attributes).forEach((name) => {
            if (ignored.indexOf(name) === -1) {
                const value = attributes[name];
                if (name.startsWith(prefix)) {
                    name = name.replace(prefix, "");
                    name = name.replace(/^(-)+/, "");
                }
                if (name.startsWith("tooltip")) {
                    if (options.tooltip === undefined) {
                        options.tooltip = {};
                    }
                    options.tooltip[strCamelCase(name.replace("tooltip", ""))] =
                        convertValue(value);
                }
                else {
                    options[strCamelCase(name)] = convertValue(value);
                }
            }
        });
        return options;
    };
    static childrenToString = (nodes) => {
        const attribs = (attributes) => {
            const values = [];
            Object.keys(attributes).forEach((key) => {
                values.push(`${key}="${attributes[key]}"`);
            });
            return values.length > 0 ? ` ${values.join(" ")}` : "";
        };
        let content = "";
        nodes.forEach((node) => {
            if (node.type === "tag") {
                content += `<${node.tagName}${attribs(node.attribs)}>`;
                content += this.childrenToString(node.children).trim();
                content += `</${node.tagName}>`;
            }
            else if (node.type === "text") {
                content += node.data.trim();
            }
        });
        return content.trim();
    };
}
//# sourceMappingURL=Utils.js.map